// Date helpers shared by Timeline/Calendar/Roadmap. All work on YYYY-MM-DD strings.

export const DAY_MS = 86400000;

export function toISO(d) {
  return d.toISOString().slice(0, 10);
}

export function parseISO(s) {
  return new Date(`${s}T00:00:00Z`);
}

export function addDays(iso, n) {
  return toISO(new Date(parseISO(iso).getTime() + n * DAY_MS));
}

export function diffDays(a, b) {
  // whole days from a to b (b - a)
  return Math.round((parseISO(b) - parseISO(a)) / DAY_MS);
}

export function todayISO() {
  return toISO(new Date());
}

export function monthLabel(year, month) {
  return new Date(Date.UTC(year, month, 1)).toLocaleDateString(undefined, {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  });
}

// 6x7 month grid: returns array of {iso, inMonth} starting Monday
export function monthGrid(year, month) {
  const first = new Date(Date.UTC(year, month, 1));
  const startOffset = (first.getUTCDay() + 6) % 7; // Monday = 0
  const start = new Date(first.getTime() - startOffset * DAY_MS);
  const cells = [];
  for (let i = 0; i < 42; i++) {
    const d = new Date(start.getTime() + i * DAY_MS);
    cells.push({ iso: toISO(d), inMonth: d.getUTCMonth() === month });
  }
  return cells;
}
